(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["judy-discount-signup"] && !Shopify.designMode) return;
  try {
    class JudyDiscountSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.entry = this.querySelector('.judy-discount-signup__entry');
      this.result = this.querySelector('[data-judy-discount-result]');
      this.status = this.querySelector('[data-judy-discount-status]');
      this.submitButton = this.querySelector('[data-judy-discount-submit]');
      this.submitSpinner = this.querySelector('[data-judy-discount-submit-spinner]');
      this.copyButton = this.querySelector('[data-judy-discount-copy]');
      this.mobilePromoCode = this.querySelector('[data-judy-mobile-promo-code]');
      this.emailInput = this.querySelector('[data-judy-discount-email]');
      this.discountReady = this.dataset.discountReady === 'true';
      this.context = this.classList.contains('judy-discount-signup--dialog') ? 'dialog' : 'footer';
      this.dialogMode = this.dataset.dialogMode || 'desktop';
      this.returnSource = this.dataset.returnSource || this.context;
      this.returnAnchor = this.dataset.returnAnchor || (this.returnSource === 'footer' ? 'judy-footer-discount' : 'judy-product-discount');
      this.dialogComponent = this.closest('dialog-component');
      this.storageKey = 'judy:email-discount:claimed';
      this.pendingStorageKey = 'judy:email-discount:pending';
      this.pendingTtl = 30 * 60 * 1000;
      this.nativeResubmitPending = false;
      this.nativeSubmissionStarted = false;
      this.submissionActive = false;
      this.submissionTimeoutMs = 15 * 1000;
      this.hcaptchaChallengeSeen = false;
      this.handleSubmit = (event) => this.submit(event);
      this.handleCopy = () => this.copyCode();
      this.handleBuy = () => this.openDiscountLink();
      this.handleClaimed = (event) => {
        if (event.detail?.source === this || !this.discountReady) return;
        this.showSuccess(false);
      };

      this.form?.addEventListener('submit', this.handleSubmit, true);
      this.copyButton?.addEventListener('click', this.handleCopy);
      window.addEventListener('judy:discount-claimed', this.handleClaimed);

      if (this.dialogMode === 'mobile') {
        this.mobileAlignmentObserver = new ResizeObserver(() => this.syncMobileEmailInset());
        this.mobileAlignmentObserver.observe(this);
        if (this.mobilePromoCode instanceof HTMLElement) {
          this.mobileAlignmentObserver.observe(this.mobilePromoCode);
        }
        window.requestAnimationFrame(() => this.syncMobileEmailInset());
      }

      if (this.restoreReturnState()) {
        return;
      }

      if (this.querySelector('[data-judy-discount-success]')) {
        if (this.discountReady) this.persistClaimed();
        this.showSuccess(false);
      } else if (
        this.discountReady &&
        (this.dataset.initialClaimed === 'true' ||
          (this.dataset.allowRememberedClaim === 'true' && this.hasRememberedClaim()))
      ) {
        this.showSuccess(false);
      }
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit, true);
      this.copyButton?.removeEventListener('click', this.handleCopy);
      this.submitButton?.removeEventListener('click', this.handleBuy);
      window.removeEventListener('judy:discount-claimed', this.handleClaimed);
      this.mobileAlignmentObserver?.disconnect();
      if (this.transitionTimer) window.clearTimeout(this.transitionTimer);
      if (this.copyTimer) window.clearTimeout(this.copyTimer);
      this.stopHcaptchaObserver();
      this.clearSubmissionWatchdog();
    }

    submit(event) {
      if (!(this.form instanceof HTMLFormElement)) return;

      if (this.classList.contains('is-success')) {
        event.preventDefault();
        return;
      }

      if (this.nativeResubmitPending) {
        this.nativeResubmitPending = false;
        return;
      }

      if (this.context === 'dialog' && this.submissionActive) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const submitter = event.submitter instanceof HTMLElement ? event.submitter : this.submitButton;
      this.prepareNativeSubmission();

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.context === 'dialog') this.beginDialogSubmission();
      this.submitWithShopifyCaptcha(submitter);
    }

    submitWithShopifyCaptcha(submitter) {
      if (!(this.form instanceof HTMLFormElement)) return;

      let submitted = false;
      const submitNatively = () => {
        if (submitted) return;
        submitted = true;
        this.nativeSubmissionStarted = true;
        this.stopHcaptchaObserver();
        this.startSubmissionWatchdog();
        this.nativeResubmitPending = true;
        this.form.requestSubmit(submitter instanceof HTMLElement ? submitter : undefined);
      };

      const protect = window.Shopify?.captcha?.protect;
      if (typeof protect !== 'function') {
        submitNatively();
        return;
      }

      try {
        protect.call(window.Shopify.captcha, this.form, submitNatively);
      } catch {
        submitNatively();
      }
    }

    setDialogSubmitLoading(isLoading) {
      this.submissionActive = isLoading;
      if (!(this.submitButton instanceof HTMLButtonElement)) return;

      this.submitButton.classList.toggle('is-loading', isLoading);
      this.submitButton.setAttribute('aria-busy', String(isLoading));
      this.submitButton.setAttribute('aria-disabled', String(isLoading));
    }

    beginDialogSubmission() {
      this.nativeSubmissionStarted = false;
      this.setDialogSubmitLoading(true);
      this.startHcaptchaObserver();
      this.startSubmissionWatchdog();
    }

    recoverDialogSubmission() {
      if (!this.submissionActive) return;

      this.nativeResubmitPending = false;
      this.nativeSubmissionStarted = false;
      this.stopHcaptchaObserver();
      this.clearSubmissionWatchdog();
      this.setDialogSubmitLoading(false);
    }

    clearSubmissionWatchdog() {
      if (this.submissionWatchdog) window.clearTimeout(this.submissionWatchdog);
      this.submissionWatchdog = null;
    }

    startSubmissionWatchdog() {
      this.clearSubmissionWatchdog();
      this.submissionWatchdog = window.setTimeout(() => this.recoverDialogSubmission(), this.submissionTimeoutMs);
    }

    startHcaptchaObserver() {
      this.stopHcaptchaObserver();
      this.hcaptchaChallengeSeen = false;

      const updateChallengeState = () => {
        const challengeVisible = this.hasVisibleHcaptchaChallenge();

        if (challengeVisible) {
          if (this.hcaptchaDismissTimer) window.clearTimeout(this.hcaptchaDismissTimer);
          this.hcaptchaDismissTimer = null;
          this.hcaptchaChallengeSeen = true;
          this.markPendingChallengeSeen();
          this.clearSubmissionWatchdog();
          return;
        }

        if (!this.hcaptchaChallengeSeen || this.nativeSubmissionStarted) return;

        if (this.hcaptchaDismissTimer) window.clearTimeout(this.hcaptchaDismissTimer);
        this.hcaptchaDismissTimer = window.setTimeout(() => {
          if (!this.hasVisibleHcaptchaChallenge() && !this.nativeSubmissionStarted) {
            this.recoverDialogSubmission();
          }
        }, 750);
      };

      this.hcaptchaObserver = new MutationObserver(updateChallengeState);
      this.hcaptchaObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'style', 'class', 'aria-hidden'],
      });

      updateChallengeState();
    }

    hasVisibleHcaptchaChallenge() {
      const frames = document.querySelectorAll('iframe[src*="hcaptcha.com"]');

      return Array.from(frames).some((frame) => {
        const source = frame.getAttribute('src') || '';
        const title = frame.getAttribute('title') || '';
        const isChallengeFrame =
          source.includes('frame=challenge') ||
          (source.includes('challenge') && !source.includes('checkbox')) ||
          title.toLowerCase().includes('hcaptcha challenge');

        if (!isChallengeFrame) return false;
        return this.isActuallyVisible(frame);
      });
    }

    isActuallyVisible(element) {
      if (!(element instanceof HTMLElement)) return false;

      if (typeof element.checkVisibility === 'function') {
        try {
          if (!element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
        } catch {}
      }

      let current = element;
      while (current instanceof HTMLElement) {
        const style = window.getComputedStyle(current);
        if (
          current.hidden ||
          current.getAttribute('aria-hidden') === 'true' ||
          style.display === 'none' ||
          style.visibility === 'hidden' ||
          Number.parseFloat(style.opacity || '1') <= 0
        ) {
          return false;
        }
        current = current.parentElement;
      }

      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    markPendingChallengeSeen() {
      const pending = this.getPending();
      if (!pending || pending.source !== this.returnSource || pending.challengeSeen === true) return;

      pending.challengeSeen = true;
      this.savePending(pending);
    }

    stopHcaptchaObserver() {
      this.hcaptchaObserver?.disconnect();
      this.hcaptchaObserver = null;
      if (this.hcaptchaDismissTimer) window.clearTimeout(this.hcaptchaDismissTimer);
      this.hcaptchaDismissTimer = null;
      this.hcaptchaChallengeSeen = false;
    }

    syncMobileEmailInset() {
      if (this.dialogMode !== 'mobile' || !(this.form instanceof HTMLElement)) return;

      const firstCharacter = this.mobilePromoCode?.querySelector('.judy-discount-signup__mobile-promo-character');
      if (!(firstCharacter instanceof HTMLElement)) return;

      const formRect = this.form.getBoundingClientRect();
      const characterRect = firstCharacter.getBoundingClientRect();
      const inset = Math.max(12, characterRect.left - formRect.left);
      this.style.setProperty('--judy-mobile-email-inset', `${inset}px`);
    }

    prepareNativeSubmission() {
      if (!(this.form instanceof HTMLFormElement)) return null;

      const pending = {
        source: this.returnSource,
        token: this.createToken(),
        createdAt: Date.now(),
        returnPath: this.dataset.returnPath || window.location.pathname,
        challengeSeen: false,
      };

      this.savePending(pending);

      let returnInput = this.form.querySelector('input[name="return_to"]');
      if (!(returnInput instanceof HTMLInputElement)) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        this.form.append(returnInput);
      }

      const returnUrl = new URL(pending.returnPath, window.location.origin);
      returnUrl.searchParams.set('judy_discount_source', pending.source);
      returnUrl.searchParams.set('judy_discount_token', pending.token);
      if (this.returnAnchor) returnUrl.hash = this.returnAnchor;
      returnInput.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
      return pending;
    }

    createToken() {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }

    getPending() {
      try {
        const pending = JSON.parse(window.sessionStorage.getItem(this.pendingStorageKey) || 'null');
        if (
          pending &&
          ['footer', 'dialog', 'mobile-dialog', 'mobile-collection-dialog'].includes(pending.source) &&
          typeof pending.token === 'string' &&
          typeof pending.createdAt === 'number' &&
          Date.now() - pending.createdAt <= this.pendingTtl
        ) {
          return pending;
        }
      } catch {}

      this.removePending();
      return null;
    }

    savePending(pending) {
      const serializedPending = JSON.stringify(pending);
      try {
        window.sessionStorage.setItem(this.pendingStorageKey, serializedPending);
      } catch {}
    }

    removePending() {
      for (const storage of [window.sessionStorage, window.localStorage]) {
        try {
          storage.removeItem(this.pendingStorageKey);
        } catch {}
      }
    }

    restoreReturnState() {
      if (!this.discountReady) return false;

      const pending = this.getPending();
      if (!pending || pending.source !== this.returnSource) return false;

      const url = new URL(window.location.href);
      const returnedSource = url.searchParams.get('judy_discount_source');
      const returnedToken = url.searchParams.get('judy_discount_token');
      const exactMatch = returnedSource === pending.source && returnedToken === pending.token;
      const challengeRetry = url.searchParams.get('judy_discount_retry') === 'challenge';
      const hasServerError = Boolean(this.status?.textContent?.trim());

      if (exactMatch && challengeRetry) {
        this.removePending();
        this.cleanReturnUrl(url);
        this.updateStatus(this.dataset.errorLabel || '');
        if (this.context === 'dialog') this.reopenDialog();
        return true;
      }

      if (!exactMatch) return false;

      if (hasServerError) {
        this.removePending();
        this.cleanReturnUrl(url);
        if (this.context === 'dialog') this.reopenDialog();
        return true;
      }

      this.removePending();

      this.cleanReturnUrl(url);
      this.persistClaimed();
      this.showSuccess(false);

      if (this.context === 'dialog') {
        this.reopenDialog();
      } else {
        window.requestAnimationFrame(() => {
          this.scrollIntoView({ behavior: 'auto', block: 'center' });
        });
      }

      return true;
    }

    cleanReturnUrl(url) {
      url.searchParams.delete('judy_discount_source');
      url.searchParams.delete('judy_discount_token');
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('judy_discount_retry');
      url.searchParams.delete('judy_discount_fallback');
      url.hash = '';
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    hasRememberedClaim() {
      try {
        return window.localStorage.getItem(this.storageKey) === 'true';
      } catch {
        return false;
      }
    }

    persistClaimed() {
      if (this.dataset.allowRememberedClaim === 'true') {
        try {
          window.localStorage.setItem(this.storageKey, 'true');
        } catch {}
      }

      window.dispatchEvent(new CustomEvent('judy:discount-claimed', { detail: { source: this } }));
    }

    showSuccess(animate) {
      if (!this.discountReady) {
        this.updateStatus(this.dataset.successLabel || '');
        return;
      }

      if (this.context === 'footer') {
        this.showFooterSuccess();
        return;
      }

      if (this.dialogMode === 'mobile') {
        this.showMobileDialogSuccess(animate);
        return;
      }

      if (!(this.entry instanceof HTMLElement) || !(this.result instanceof HTMLElement)) return;

      this.result.hidden = false;
      this.classList.add('is-success');

      if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.entry.hidden = true;
        return;
      }

      this.classList.add('is-transitioning');
      this.transitionTimer = window.setTimeout(() => {
        this.entry.hidden = true;
        this.classList.remove('is-transitioning');
      }, 280);
    }

    showMobileDialogSuccess(animate) {
      if (!(this.mobilePromoCode instanceof HTMLOutputElement)) return;

      this.setDialogSubmitLoading(false);
      const discountCode = this.dataset.discountCode || '';
      this.mobilePromoCode.replaceChildren();
      Array.from(discountCode).forEach((character) => {
        const characterCell = document.createElement('span');
        characterCell.className = 'judy-discount-signup__mobile-promo-character';
        characterCell.textContent = character;
        characterCell.setAttribute('aria-hidden', 'true');
        this.mobilePromoCode.append(characterCell);
      });
      window.requestAnimationFrame(() => this.syncMobileEmailInset());
      this.mobilePromoCode.setAttribute(
        'aria-label',
        `${this.dataset.discountLabel || ''}: ${discountCode}`
      );
      this.classList.add('is-success');

      if (this.copyButton instanceof HTMLButtonElement) {
        this.copyButton.disabled = false;
      }

      if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.classList.add('is-transitioning');
      this.transitionTimer = window.setTimeout(() => {
        this.classList.remove('is-transitioning');
      }, 280);
    }

    showFooterSuccess() {
      if (!(this.entry instanceof HTMLElement)) return;

      this.classList.add('is-success');
      this.entry.hidden = false;

      if (this.emailInput instanceof HTMLInputElement) {
        this.emailInput.type = 'text';
        this.emailInput.value = this.dataset.discountCode || '';
        this.emailInput.readOnly = true;
        this.emailInput.required = false;
        this.emailInput.removeAttribute('placeholder');
        this.emailInput.setAttribute('aria-label', this.dataset.discountLabel || '');
      }

      if (this.submitButton instanceof HTMLButtonElement) {
        this.submitButton.type = 'button';
        this.submitButton.textContent = this.dataset.buyLabel || '';
        this.submitButton.addEventListener('click', this.handleBuy);
      }
    }

    openDiscountLink() {
      const href = this.dataset.discountHref || '';
      if (href) window.location.assign(href);
    }

    async copyCode() {
      const code = this.dataset.discountCode || '';
      if (!code || !(this.copyButton instanceof HTMLButtonElement)) return;

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.append(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }

        this.copyButton.textContent = this.dataset.copiedLabel || '';
        this.updateStatus(this.dataset.copiedLabel || '');
        this.copyTimer = window.setTimeout(() => {
          if (this.copyButton) this.copyButton.textContent = this.dataset.copyLabel || '';
        }, 1600);
      } catch {
        this.updateStatus(this.dataset.errorLabel || '');
      }
    }

    updateStatus(message) {
      if (this.status) this.status.textContent = message;
    }

    reopenDialog() {
      if (this.context !== 'dialog' || this.dataset.reopenOnSuccess !== 'true') return;
      const component = this.closest('dialog-component');
      if (!component) return;

      const openDialog = () => {
        window.requestAnimationFrame(() => component.showDialog?.());
      };

      customElements.whenDefined('dialog-component').then(() => {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', openDialog, { once: true });
          return;
        }

        openDialog();
      });
    }
  }

  if (!customElements.get('judy-discount-signup')) {
    customElements.define('judy-discount-signup', JudyDiscountSignup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judy-footer-carousel"] && !Shopify.designMode) return;
  try {
    class JudyFooterCarousel extends HTMLElement {
    connectedCallback() {
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.fallbackIndex = 0;
      this.fallbackActive = false;
      this.handleDesktopChange = () => this.observe();
      this.handleVisibilityChange = () => this.syncAutoplay();
      this.handleSlideSelect = (event) => this.syncVideos(event.detail?.slide);
      this.handleControlClick = (event) => this.handleControls(event);
      this.desktopQuery.addEventListener('change', this.handleDesktopChange);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.querySelector('slideshow-component')?.addEventListener('slideshow:select', this.handleSlideSelect);
      this.addEventListener('click', this.handleControlClick);
      this.observe();
      this.whenSlideshowReady().then((slideshow) => {
        if (slideshow) {
          this.deactivateFallback(slideshow);
          this.syncAutoplay();
        } else {
          this.activateFallback();
        }
      });
      customElements.whenDefined('slideshow-component').then(() => {
        this.whenSlideshowReady().then((slideshow) => {
          if (!slideshow || !this.isConnected) return;
          this.deactivateFallback(slideshow);
          this.syncAutoplay();
        });
      });
    }

    disconnectedCallback() {
      this.desktopQuery?.removeEventListener('change', this.handleDesktopChange);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.querySelector('slideshow-component')?.removeEventListener('slideshow:select', this.handleSlideSelect);
      this.removeEventListener('click', this.handleControlClick);
      this.observer?.disconnect();
      this.stopAutoplay();
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    get slideshow() {
      return this.querySelector('slideshow-component');
    }

    get shouldAutoplay() {
      return this.dataset.judyFooterAutoplay !== 'false' && this.querySelectorAll('slideshow-slide').length > 1;
    }

    isSlideshowReady(slideshow = this.slideshow) {
      return (
        typeof slideshow?.next === 'function' &&
        this.querySelectorAll('slideshow-slide').length > 1 &&
        slideshow.isConnected &&
        Number.isInteger(slideshow.current)
      );
    }

    async whenSlideshowReady() {
      if (this.isSlideshowReady()) return this.slideshow;

      const isDefined = await Promise.race([
        customElements.whenDefined('slideshow-component').then(() => true),
        new Promise((resolve) => window.setTimeout(() => resolve(false), 1800)),
      ]);
      if (!isDefined) return undefined;
      // `slideshow.js` is loaded by Horizon's DOM-aware module loader. It can
      // be defined a little before its internal Scroller is ready, especially
      // when the footer has just entered the viewport.
      for (let attempt = 0; attempt < 60; attempt += 1) {
        const slideshow = this.slideshow;
        if (this.isSlideshowReady(slideshow)) {
          // Wait for two frames after definition so Horizon has created its
          // internal scroller before an arrow or timer asks it to move.
          await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          return slideshow;
        }
        await new Promise((resolve) => window.setTimeout(resolve, 50));
      }
      return undefined;
    }

    get fallbackSlides() {
      return Array.from(this.querySelectorAll('slideshow-slide'));
    }

    activateFallback() {
      if (this.fallbackActive || !this.desktopQuery?.matches || this.isSlideshowReady()) return;

      const slideshow = this.slideshow;
      const slides = this.fallbackSlides;
      if (!(slideshow instanceof HTMLElement) || slides.length < 2) return;

      this.fallbackActive = true;
      // Horizon normally unlocks the scroll track after its module is ready.
      // Keep the same track visible for the local fallback when that import is
      // delayed or blocked by the visitor's network.
      slideshow.setAttribute('in-viewport', '');
      this.fallbackIndex = Math.max(0, slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
      this.selectFallback(this.fallbackIndex, true);
      this.syncAutoplay();
    }

    deactivateFallback(slideshow) {
      if (!this.fallbackActive) return;

      const track = this.querySelector('slideshow-slides');
      track?.style.removeProperty('transform');
      track?.style.removeProperty('transition');
      this.fallbackActive = false;
      this.stopAutoplay();
      slideshow.select(this.fallbackIndex, undefined, { animate: false });
    }

    selectFallback(index, instant = false) {
      const slides = this.fallbackSlides;
      const track = this.querySelector('slideshow-slides');
      if (!this.fallbackActive || !track || slides.length < 2) return;

      this.fallbackIndex = (index + slides.length) % slides.length;
      track.style.transition = instant ? 'none' : 'transform 360ms ease';
      track.style.transform = `translateX(-${this.fallbackIndex * 100}%)`;
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== this.fallbackIndex));
      });
      this.syncVideos(slides[this.fallbackIndex]);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = undefined;
      this.slideshow?.pause?.();
    }

    async syncAutoplay() {
      this.stopAutoplay();
      if (!this.desktopQuery?.matches || document.hidden) return;
      if (this.fallbackActive) {
        if (!this.shouldAutoplay) return;
        const seconds = Math.min(5, Math.max(1, Number(this.dataset.judyFooterAutoplaySpeed) || 5));
        this.autoplayTimer = window.setInterval(() => this.selectFallback(this.fallbackIndex + 1), seconds * 1000);
        return;
      }
      const slideshow = await this.whenSlideshowReady();
      // A visibility, hydration, or breakpoint change may have requested a
      // newer playback state while the slideshow module was becoming ready.
      this.stopAutoplay();
      if (this.fallbackActive) {
        this.syncAutoplay();
        return;
      }
      if (!this.desktopQuery?.matches || document.hidden || !slideshow || !this.shouldAutoplay) return;
      const seconds = Math.min(5, Math.max(1, Number(this.dataset.judyFooterAutoplaySpeed) || 5));
      // Keep Horizon's own autoplay suspended. A single local timer prevents
      // duplicate timers and remains stable when the footer enters the viewport
      // after the slideshow component has already connected.
      slideshow.pause();
      this.autoplayTimer = window.setInterval(() => {
        if (!this.desktopQuery?.matches || document.hidden) return;
        slideshow.next();
      }, seconds * 1000);
    }

    async handleControls(event) {
      const control = event.target.closest('[data-judy-footer-carousel-action], [data-judy-footer-carousel-index]');
      if (!(control instanceof HTMLButtonElement) || !this.contains(control)) return;

      event.preventDefault();
      event.stopPropagation();
      const index = control.dataset.judyFooterCarouselIndex;
      if (this.fallbackActive || !this.isSlideshowReady()) {
        this.activateFallback();
        if (!this.fallbackActive) return;
        if (index !== undefined) {
          this.selectFallback(Number(index));
        } else if (control.dataset.judyFooterCarouselAction === 'previous') {
          this.selectFallback(this.fallbackIndex - 1);
        } else {
          this.selectFallback(this.fallbackIndex + 1);
        }
        this.syncAutoplay();
        return;
      }

      const slideshow = this.slideshow;
      if (index !== undefined) {
        slideshow.select(Number(index));
      } else if (control.dataset.judyFooterCarouselAction === 'previous') {
        slideshow.previous();
      } else {
        slideshow.next();
      }

      requestAnimationFrame(() => this.syncVideos());
      this.syncAutoplay();
    }

    observe() {
      if (!this.desktopQuery.matches) {
        this.stopAutoplay();
        this.querySelectorAll('video').forEach((video) => video.pause());
        return;
      }
      if (this.dataset.hydrated === 'true') {
        this.syncVideos();
        this.syncAutoplay();
        return;
      }
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.hydrateVideos();
          this.observer?.disconnect();
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this);
    }

    hydrateVideos() {
      if (this.dataset.hydrated === 'true') return;
      this.dataset.hydrated = 'true';
      this.querySelectorAll('[data-judy-footer-video]').forEach((video) => {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src || '';
          source.removeAttribute('data-src');
        });
        video.load();
      });
      this.syncVideos();
      this.syncAutoplay();
    }

    syncVideos(activeSlide) {
      const slides = Array.from(this.querySelectorAll('slideshow-slide'));
      const currentIndexFromSlideshow = Number(this.slideshow?.current);
      activeSlide ||= slides[currentIndexFromSlideshow] || this.querySelector('slideshow-slide[aria-hidden="false"]');
      const currentIndex = slides.indexOf(activeSlide);
      this.querySelectorAll('[data-judy-footer-carousel-index]').forEach((button) => {
        button.setAttribute('aria-current', String(Number(button.dataset.judyFooterCarouselIndex) === currentIndex));
      });
      const canAutoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('[data-judy-footer-video]').forEach((video) => {
        const isActive = video.closest('slideshow-slide') === activeSlide;
        if (canAutoplay && isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }
  }

  if (!customElements.get('judy-footer-carousel')) {
    customElements.define('judy-footer-carousel', JudyFooterCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judy-show-dialog"] && !Shopify.designMode) return;
  try {
    if (!window.JudyShowDialogController) {
    class JudyShowDialogController {
      constructor(scope) {
        this.scope = scope;
        this.dialogComponent = scope.querySelector('[data-judy-show-dialog]');
        this.dialog = this.dialogComponent?.querySelector('dialog');
        this.mediaTrack = this.dialogComponent?.querySelector('[data-judy-show-media-track]');
        this.mediaStage = this.dialogComponent?.querySelector('[data-judy-show-media-stage]');
        this.productList = this.dialogComponent?.querySelector('[data-judy-show-product-list]');
        this.relatedProducts = this.dialogComponent?.querySelector('[data-judy-show-related]');
        this.previousEntryButton = this.dialogComponent?.querySelector('[data-judy-show-entry-change="-1"]');
        this.nextEntryButton = this.dialogComponent?.querySelector('[data-judy-show-entry-change="1"]');
        this.mediaIndex = 0;
        this.videoMuted = true;
      }

      initialize() {
        if (
          !(this.dialogComponent instanceof HTMLElement) ||
          !(this.dialog instanceof HTMLDialogElement) ||
          !(this.mediaTrack instanceof HTMLElement) ||
          this.scope.dataset.judyShowDialogInitialized === 'true'
        ) {
          return;
        }

        this.scope.dataset.judyShowDialogInitialized = 'true';
        this.onScopeClick = (event) => this.handleScopeClick(event);
        this.onMediaPause = (event) => this.handleMediaPause(event);
        this.onDialogOpen = () => this.handleDialogOpen();
        this.onDialogClose = () => this.handleDialogClose();
        this.onFilterChange = () => this.handleFilterChange();

        this.scope.addEventListener('click', this.onScopeClick);
        this.mediaStage?.addEventListener('pause', this.onMediaPause, true);
        this.dialogComponent.addEventListener('dialog:open', this.onDialogOpen);
        this.dialogComponent.addEventListener('dialog:close', this.onDialogClose);
        this.scope.addEventListener('judy-show:filter-change', this.onFilterChange);
        this.updateEntryNavigation();
      }

      destroy() {
        this.scope.removeEventListener('click', this.onScopeClick);
        this.mediaStage?.removeEventListener('pause', this.onMediaPause, true);
        this.dialogComponent?.removeEventListener('dialog:open', this.onDialogOpen);
        this.dialogComponent?.removeEventListener('dialog:close', this.onDialogClose);
        this.scope.removeEventListener('judy-show:filter-change', this.onFilterChange);
        this.resetVideos();
        delete this.scope.dataset.judyShowDialogInitialized;
      }

      handleScopeClick(event) {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-judy-show-trigger]');
        if (trigger instanceof HTMLElement && this.scope.contains(trigger)) {
          event.preventDefault();
          this.open(trigger);
          return;
        }

        const entryChange = event.target.closest('[data-judy-show-entry-change]');
        if (entryChange instanceof HTMLButtonElement && this.dialogComponent.contains(entryChange)) {
          event.preventDefault();
          this.changeEntry(Number(entryChange.dataset.judyShowEntryChange));
          return;
        }

        const mediaChange = event.target.closest('[data-judy-show-media-change]');
        if (mediaChange instanceof HTMLButtonElement && this.dialogComponent.contains(mediaChange)) {
          event.preventDefault();
          this.updateMedia(this.mediaIndex + Number(mediaChange.dataset.judyShowMediaChange));
          return;
        }

        const videoToggle = event.target.closest('[data-judy-show-video-toggle]');
        if (videoToggle instanceof HTMLButtonElement && this.dialogComponent.contains(videoToggle)) {
          event.preventDefault();
          this.toggleVideo(videoToggle);
          return;
        }

        const videoSoundToggle = event.target.closest('[data-judy-show-video-sound-toggle]');
        if (videoSoundToggle instanceof HTMLButtonElement && this.dialogComponent.contains(videoSoundToggle)) {
          event.preventDefault();
          this.toggleVideoSound(videoSoundToggle);
          return;
        }

        this.navigateFromRelatedProduct(event);
      }

      handleMediaPause(event) {
        if (!(event.target instanceof HTMLVideoElement)) return;
        const item = event.target.closest('[data-judy-show-media-item]');
        item?.classList.remove('is-playing');
        if (item instanceof HTMLElement && !item.classList.contains('is-ended')) {
          this.updateVideoToggleLabel(item, 'play');
        }
      }

      handleDialogClose() {
        this.resetVideos();
        this.videoMuted = true;
        if (!this.navigationPending) this.currentTrigger?.focus();
      }

      handleDialogOpen() {
        window.requestAnimationFrame(() => this.autoPlayActiveVideo());
      }

      handleFilterChange() {
        const triggers = this.availableTriggers();
        if (!this.currentTrigger || triggers.includes(this.currentTrigger)) {
          this.updateEntryNavigation();
          return;
        }

        if (this.dialog?.open && triggers[0] instanceof HTMLElement) this.activate(triggers[0]);
        else this.currentTrigger = undefined;
        this.updateEntryNavigation();
      }

      availableTriggers() {
        return Array.from(this.scope.querySelectorAll('[data-judy-show-trigger]')).filter((trigger) => {
          if (!(trigger instanceof HTMLElement)) return false;
          const feedCard = trigger.closest('[data-judy-shows-feed-card]');
          return !(feedCard instanceof HTMLElement) || !feedCard.hidden;
        });
      }

      open(trigger) {
        if (!(trigger instanceof HTMLElement) || !this.dialog) return;
        if (!this.dialog.open) this.videoMuted = true;
        this.activate(trigger);

        if (typeof this.dialogComponent.showDialog === 'function') this.dialogComponent.showDialog();
        else if (!this.dialog.open) {
          this.dialog.showModal();
          this.handleDialogOpen();
        }
      }

      changeEntry(change) {
        const triggers = this.availableTriggers();
        const currentIndex = triggers.indexOf(this.currentTrigger);
        const nextTrigger = triggers[currentIndex + change];
        if (!(nextTrigger instanceof HTMLElement)) return;

        const focusedEntryControl =
          document.activeElement === this.previousEntryButton || document.activeElement === this.nextEntryButton;
        this.activate(nextTrigger);

        if (!focusedEntryControl) return;
        const preferredControl = change > 0 ? this.nextEntryButton : this.previousEntryButton;
        const fallbackControl = change > 0 ? this.previousEntryButton : this.nextEntryButton;
        if (preferredControl instanceof HTMLButtonElement && !preferredControl.hidden) preferredControl.focus();
        else if (fallbackControl instanceof HTMLButtonElement && !fallbackControl.hidden) fallbackControl.focus();
        else this.dialog?.focus();
      }

      activate(trigger) {
        this.currentTrigger = trigger;
        this.mediaIndex = 0;
        this.loadMedia(trigger);
        this.updateMedia(0);
        this.updateEntryNavigation();
        this.scope.dispatchEvent(
          new CustomEvent('judy-show:open', {
            bubbles: true,
            detail: {
              cardIndex: Number(trigger.dataset.judyShowIndex || 0),
              trigger,
              dialog: this.dialog,
            },
          })
        );
      }

      loadMedia(trigger) {
        const mediaTemplate = document.getElementById(trigger.dataset.judyShowTemplateId || '');
        const productsTemplate = document.getElementById(trigger.dataset.judyShowProductsTemplateId || '');
        if (!(mediaTemplate instanceof HTMLTemplateElement) || !(this.mediaTrack instanceof HTMLElement)) return;

        this.resetVideos();
        this.mediaTrack.replaceChildren(mediaTemplate.content.cloneNode(true));
        this.bindVideoEndEvents();
        this.syncVideoSoundPreference();
        this.updateInformation(trigger);

        if (this.productList instanceof HTMLElement) {
          if (productsTemplate instanceof HTMLTemplateElement) {
            this.productList.replaceChildren(productsTemplate.content.cloneNode(true));
          } else {
            this.productList.replaceChildren();
          }
          if (this.relatedProducts instanceof HTMLElement)
            this.relatedProducts.hidden = this.productList.children.length === 0;
        }
      }

      updateInformation(trigger) {
        const emptyValue = '-';
        const setText = (selector, value) => {
          const element = this.dialogComponent.querySelector(selector);
          if (element instanceof HTMLElement) element.textContent = value || emptyValue;
        };
        const setOptionalText = (selector, value) => {
          const element = this.dialogComponent.querySelector(selector);
          if (!(element instanceof HTMLElement)) return;
          element.hidden = !value;
          element.textContent = value || '';
        };

        setOptionalText('[data-judy-show-introduction]', trigger.dataset.judyShowIntroduction);
        setText('[data-judy-show-review-author]', trigger.dataset.judyShowReviewAuthor);
        setText('[data-judy-show-review-text]', trigger.dataset.judyShowReviewBody);
        setText('[data-judy-show-source-account]', trigger.dataset.judyShowSourceAccount);
        setText('[data-judy-show-location]', trigger.dataset.judyShowLocation);

        const sourceLink = this.dialogComponent.querySelector('[data-judy-show-source-link]');
        if (sourceLink instanceof HTMLAnchorElement) {
          const sourceUrl = trigger.dataset.judyShowSourceUrl || '';
          if (sourceUrl) {
            sourceLink.href = sourceUrl;
            sourceLink.removeAttribute('aria-disabled');
          } else {
            sourceLink.removeAttribute('href');
            sourceLink.setAttribute('aria-disabled', 'true');
          }
        }

        const editedDate = trigger.dataset.judyShowEditedAt || '';
        const editedDateElement = this.dialogComponent.querySelector('[data-judy-show-edited-date]');
        if (editedDateElement instanceof HTMLTimeElement) {
          editedDateElement.dateTime = editedDate;
          editedDateElement.textContent = editedDate || emptyValue;
        }

        const avatar = this.dialogComponent.querySelector('[data-judy-show-avatar]');
        if (!(avatar instanceof HTMLElement)) return;

        avatar.replaceChildren();
        const avatarUrl = trigger.dataset.judyShowAvatarUrl || '';
        if (!avatarUrl) return;

        const image = new Image();
        image.src = avatarUrl;
        image.alt = '';
        image.width = 144;
        image.height = 144;
        image.decoding = 'async';
        avatar.append(image);
      }

      mediaItems() {
        if (!(this.mediaTrack instanceof HTMLElement)) return [];
        return Array.from(this.mediaTrack.querySelectorAll(':scope > [data-judy-show-media-item]'));
      }

      updateMedia(index) {
        const items = this.mediaItems();
        const previous = this.dialogComponent.querySelector('[data-judy-show-media-change="-1"]');
        const next = this.dialogComponent.querySelector('[data-judy-show-media-change="1"]');
        if (!items.length) {
          if (previous instanceof HTMLButtonElement) previous.hidden = true;
          if (next instanceof HTMLButtonElement) next.hidden = true;
          return;
        }

        const previousIndex = this.mediaIndex;
        this.mediaIndex = Math.max(0, Math.min(items.length - 1, Number(index) || 0));
        items.forEach((item, itemIndex) => {
          const active = itemIndex === this.mediaIndex;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
          if (!active) {
            item.querySelectorAll('video').forEach((video) => {
              video.pause();
              video.currentTime = 0;
            });
            item.classList.remove('is-playing', 'is-ended');
            this.updateVideoToggleLabel(item, 'play');
          }
        });

        const activeItem = items[this.mediaIndex];
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (
          previousIndex !== this.mediaIndex &&
          activeItem?.dataset.judyShowMediaType === 'image' &&
          !reduceMotion &&
          typeof activeItem.animate === 'function'
        ) {
          const direction = this.mediaIndex > previousIndex ? 1 : -1;
          activeItem.animate(
            [
              { opacity: 0, transform: `translateX(${direction * 1.5}rem)` },
              { opacity: 1, transform: 'translateX(0)' },
            ],
            { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
        }

        const hasMultipleMedia = items.length > 1;
        if (previous instanceof HTMLButtonElement) {
          previous.hidden = !hasMultipleMedia;
          previous.disabled = this.mediaIndex === 0;
        }
        if (next instanceof HTMLButtonElement) {
          next.hidden = !hasMultipleMedia;
          next.disabled = this.mediaIndex === items.length - 1;
        }

        this.autoPlayActiveVideo();
      }

      updateEntryNavigation() {
        const triggers = this.availableTriggers();
        const currentIndex = triggers.indexOf(this.currentTrigger);
        if (this.previousEntryButton instanceof HTMLButtonElement) {
          this.previousEntryButton.hidden = currentIndex <= 0;
        }
        if (this.nextEntryButton instanceof HTMLButtonElement) {
          this.nextEntryButton.hidden = currentIndex < 0 || currentIndex >= triggers.length - 1;
        }
      }

      toggleVideo(toggle) {
        const item = toggle.closest('[data-judy-show-media-item]');
        const video = item?.querySelector('video');
        if (!(item instanceof HTMLElement) || !(video instanceof HTMLVideoElement)) return;

        if (video.paused) {
          if (item.classList.contains('is-ended')) video.currentTime = 0;
          item.classList.remove('is-ended');
          video
            .play()
            .then(() => {
              item.classList.add('is-playing');
              this.updateVideoToggleLabel(item, 'pause');
            })
            .catch(() => {
              item.classList.remove('is-playing');
              this.updateVideoToggleLabel(item, 'play');
            });
        } else {
          video.pause();
          item.classList.remove('is-playing');
          this.updateVideoToggleLabel(item, 'play');
        }
      }

      toggleVideoSound(toggle) {
        const item = toggle.closest('[data-judy-show-media-item]');
        const video = item?.querySelector('video');
        if (!(video instanceof HTMLVideoElement)) return;

        this.videoMuted = !video.muted;
        this.syncVideoSoundPreference();
      }

      syncVideoSoundPreference() {
        this.mediaItems().forEach((item) => {
          const video = item.querySelector('video');
          const toggle = item.querySelector('[data-judy-show-video-sound-toggle]');
          if (!(video instanceof HTMLVideoElement)) return;

          video.muted = this.videoMuted;
          video.defaultMuted = this.videoMuted;

          if (!(toggle instanceof HTMLButtonElement)) return;
          toggle.dataset.muted = String(this.videoMuted);
          toggle.setAttribute('aria-pressed', String(!this.videoMuted));
          const label = this.videoMuted ? toggle.dataset.unmuteLabel : toggle.dataset.muteLabel;
          if (label) toggle.setAttribute('aria-label', label);
        });
      }

      autoPlayActiveVideo() {
        if (!this.dialog?.open || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

        const activeItem = this.mediaItems()[this.mediaIndex];
        const video = activeItem?.querySelector('video');
        if (!(activeItem instanceof HTMLElement) || !(video instanceof HTMLVideoElement)) return;

        this.syncVideoSoundPreference();
        if (!video.paused) return;

        activeItem.classList.remove('is-ended');
        video
          .play()
          .then(() => {
            activeItem.classList.add('is-playing');
            this.updateVideoToggleLabel(activeItem, 'pause');
          })
          .catch(() => {
            activeItem.classList.remove('is-playing');
            this.updateVideoToggleLabel(activeItem, 'play');
          });
      }

      bindVideoEndEvents() {
        this.mediaItems().forEach((item) => {
          const video = item.querySelector('video');
          if (!(video instanceof HTMLVideoElement) || video.dataset.judyShowEndBound === 'true') return;

          video.dataset.judyShowEndBound = 'true';
          video.addEventListener('ended', () => {
            item.classList.remove('is-playing');
            item.classList.add('is-ended');
            this.updateVideoToggleLabel(item, 'replay');
          });
        });
      }

      resetVideos() {
        this.mediaItems().forEach((item) => {
          item.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.currentTime = 0;
          });
          item.classList.remove('is-playing', 'is-ended');
          this.updateVideoToggleLabel(item, 'play');
        });
      }

      updateVideoToggleLabel(item, state) {
        const toggle = item.querySelector('[data-judy-show-video-toggle]');
        if (!(toggle instanceof HTMLButtonElement)) return;
        const label = toggle.dataset[`${state}Label`];
        if (label) toggle.setAttribute('aria-label', label);
      }

      async navigateFromRelatedProduct(event) {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          this.navigationPending ||
          !(event.target instanceof Element)
        ) {
          return;
        }

        const link = event.target.closest('[data-judy-show-product-link]');
        if (!(link instanceof HTMLAnchorElement) || !link.href || (link.target && link.target !== '_self')) return;

        event.preventDefault();
        this.navigationPending = true;

        try {
          if (typeof this.dialogComponent.closeDialog === 'function') await this.dialogComponent.closeDialog();
          else this.dialog?.close();

          document.dispatchEvent(new CustomEvent('judy:page-loading'));
          window.location.assign(link.href);
        } catch {
          this.navigationPending = false;
        }
      }
    }

    window.JudyShowDialogController = JudyShowDialogController;
    window.initializeJudyShowDialogScopes = (root = document) => {
      if (!(root instanceof Document) && !(root instanceof HTMLElement)) return;
      const scopes =
        root instanceof HTMLElement && root.matches('[data-judy-show-scope]')
          ? [root, ...root.querySelectorAll('[data-judy-show-scope]')]
          : root.querySelectorAll('[data-judy-show-scope]');

      scopes.forEach((scope) => {
        if (!(scope instanceof HTMLElement) || scope.judyShowDialogController) return;
        const controller = new JudyShowDialogController(scope);
        controller.initialize();
        scope.judyShowDialogController = controller;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => window.initializeJudyShowDialogScopes(), { once: true });
    } else {
      window.initializeJudyShowDialogScopes();
    }

    document.addEventListener('shopify:section:load', (event) => window.initializeJudyShowDialogScopes(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const scopes = event.target.matches('[data-judy-show-scope]')
        ? [event.target, ...event.target.querySelectorAll('[data-judy-show-scope]')]
        : event.target.querySelectorAll('[data-judy-show-scope]');
      scopes.forEach((scope) => scope.judyShowDialogController?.destroy());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
